/* eslint-disable import/first */
import React from 'react';
import DrawerPwa from '../../../components/DrawerPwa';
import PaymentMethodList from './PaymentMethodList';
import DialogBox from '../../../components/DialogBox';
import { FormattedMessage } from 'react-intl';
import css from './index.module.scss';

const PaymentMethodDrawer = ({
  isDesktop,
  paymentOpen,
  handlePaymentDrawer,
  paymentApiStatus,
  paymentMethod,
  handlePayment,
  iconList,
  paymentHeading,
  paymentMode,
  setPaymentOpen,
  makePayment,
  checked,
  selectedValue,
  handleChangeCheckbox,
  disableMakePayment,
  handleCardToken,
  cardToken,
  setCardNumber,
  setSubPayment,
  setPaymentMode,
  closePaymentPopup,
  checkLightningPay,
  toggleLighteningPayHandler,
  countryLightningPayStatus,
  lightningPayMaxAmount,
  currency,
}) => {
  return (
    <>
      {!isDesktop ? (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={paymentOpen}
          className={css.nobg}
          onClose={closePaymentPopup}
          hideCloseButton
        >
          <PaymentMethodList
            closePaymentPopup={closePaymentPopup}
            checkLightningPay={checkLightningPay}
            countryLightningPayStatus={countryLightningPayStatus}
            setCardNumber={setCardNumber}
            isDesktop={isDesktop}
            setSubPayment={setSubPayment}
            paymentOpen={paymentOpen}
            handlePaymentDrawer={handlePaymentDrawer}
            paymentApiStatus={paymentApiStatus}
            paymentMethod={paymentMethod}
            handlePayment={handlePayment}
            iconList={iconList}
            selectedValue={selectedValue}
            toggleLighteningPayHandler={toggleLighteningPayHandler}
            paymentHeading={paymentHeading}
            paymentMode={paymentMode}
            setPaymentOpen={setPaymentOpen}
            makePayment={makePayment}
            currency={currency}
            checked={checked}
            handleChangeCheckbox={handleChangeCheckbox}
            disableMakePayment={disableMakePayment}
            handleCardToken={handleCardToken}
            cardToken={cardToken}
            lightningPayMaxAmount={lightningPayMaxAmount}
          />
        </DrawerPwa>
      ) : (
        <DialogBox
          title={
            <FormattedMessage id="checkout_paymentmode" defaultMessage="Select Payment Mode" />
          }
          size="sm"
          isOpen={paymentOpen}
          onClose={closePaymentPopup}
          hideCloseButton
        >
          <PaymentMethodList
            closePaymentPopup={closePaymentPopup}
            toggleLighteningPayHandler={toggleLighteningPayHandler}
            countryLightningPayStatus={countryLightningPayStatus}
            checkLightningPay={checkLightningPay}
            setCardNumber={setCardNumber}
            isDesktop={isDesktop}
            setSubPayment={setSubPayment}
            paymentOpen={paymentOpen}
            handlePaymentDrawer={handlePaymentDrawer}
            paymentApiStatus={paymentApiStatus}
            paymentMethod={paymentMethod}
            handlePayment={handlePayment}
            selectedValue={selectedValue}
            iconList={iconList}
            currency={currency}
            paymentHeading={paymentHeading}
            paymentMode={paymentMode}
            setPaymentOpen={setPaymentOpen}
            makePayment={makePayment}
            checked={checked}
            handleChangeCheckbox={handleChangeCheckbox}
            disableMakePayment={disableMakePayment}
            handleCardToken={handleCardToken}
            cardToken={cardToken}
            lightningPayMaxAmount={lightningPayMaxAmount}
          />
        </DialogBox>
      )}
    </>
  );
};

export default PaymentMethodDrawer;
